import { z } from 'zod';
import { IsoTimestamp } from './common';

export const AdminNote = z.object({
  noteId: z.string().uuid(),
  userId: z.string(),
  authorEmail: z.string().email(),
  authorUserId: z.string(),
  body: z.string().min(1).max(5000),
  createdAt: IsoTimestamp,
});
export type AdminNote = z.infer<typeof AdminNote>;

export const CreateAdminNoteRequest = z.object({
  body: z.string().min(1).max(5000),
});
export type CreateAdminNoteRequest = z.infer<typeof CreateAdminNoteRequest>;
